import Application from './Application';
import GrantSummary from './GrantSummary';
import Attachment from './Attachment';
import SubAwardRecommendation from './SubAwardRecommendation';
import Comments from './Comments';
import SubGrant from './SubGrant';

export {GrantSummary, Attachment, SubAwardRecommendation, SubGrant, Application, Comments};

export default {
  SubApplication: Application,
  SubAwardRecommendation: SubAwardRecommendation,
  SubGrant: SubGrant,
  SubGrantSummary: GrantSummary,
  SubAttachment: Attachment,
  SubComments: Comments,
};
